import { Stack, useTheme } from "@mui/material";
import type { FC } from "react";
import { ExpandableText } from "web_myplann/Shared/Components/ExpandableText";
import { MultiLineText } from "web_myplann/Shared/Components/MultiLineText";

type Props = {
	label: string | null | undefined;
	text: string | null | undefined;
	maxLines?: number;
};

export const DataNote: FC<Props> = ({ label, text, maxLines = 4 }) => {
	const theme = useTheme();

	if (!text) {
		return null;
	}

	return (
		<Stack direction="column" alignItems="left" gap={0.5} py={0.4}>
			<MultiLineText
				variant="deprecatedBody1"
				color={theme.palette.deprecated.grey[500]}
			>
				{label}
			</MultiLineText>

			<ExpandableText
				text={text}
				lines={maxLines}
				variant="deprecatedBody1"
				color={theme.palette.deprecated.grey[700]}
				toggle="showMore"
				clampHtml={false}
			/>
		</Stack>
	);
};
